export const EMPTY_STUB = '—';
